/**
 * Brazilian Portuguese (pt-BR) mappings for NFL Dashboard
 * Translations for both desktop and mobile NFL components
 */

export const nflDashPtBR = {
  // Header & Navigation
  "Sports Hub • NFL": "Centro Esportivo • NFL",
  "NFL Dashboard": "Terminal NFL",
  "Track live games, standings, and teams from the National Football League": "Acompanhe jogos ao vivo, classificações e times da National Football League",
  "NFL Football": "Futebol Americano NFL",
  "Live scores, upcoming games, and real-time updates": "Placar ao vivo, próximos jogos e atualizações em tempo real",
  "Live scores & stats": "Placar ao vivo e estatísticas",
  "Live games, standings, players, and team data from the National Football League": "Jogos ao vivo, classificação, jogadores e dados dos times da National Football League",
  "Live Updates": "Atualizações Ao Vivo",
  "Teams": "Times",

  // Beta Notice
  "All AI picks saved to chat history.": "Todas as apostas da IA salvas no histórico do chat.",
  "All AI picks saved to chat history": "Todas as apostas da IA salvas no histórico do chat",
  "Go to chat to dive deeper.": "Vá para o chat para se aprofundar.",
  "Go to chat to dive deeper": "Vá para o chat para se aprofundar",
  "v4 Beta": "v4 Beta",
  "Not all features available yet": "Nem todos os recursos disponíveis ainda",
  "v4 Beta • Not all features available yet": "v4 Beta • Nem todos os recursos disponíveis ainda",

  // Filters Section
  "Game Date": "Data do Jogo",
  "Date": "Data",
  "Status": "Status",
  "Filters": "Filtros",
  "Refresh": "Atualizar",
  "Loading...": "Carregando...",
  "Season": "Temporada",
  "Week": "Semana",
  "Select Season": "Selecionar Temporada",
  "Select Week": "Selecionar Semana",
  "Season": "Temporada",

  // Status Options
  "All Games": "Todos os Jogos",
  "Live Only": "Apenas Ao Vivo",
  "Upcoming": "Próximos",
  "Finished": "Finalizados",
  "Upcoming Games": "Próximos Jogos",
  "Games": "Jogos",

  // Stats Bar Labels
  "Total Games": "Total de Jogos",
  "Total": "Total",
  "Live": "Ao Vivo",
  "Next": "Próximos",
  "Done": "Concluídos",

  // Game Status
  "LIVE": "AO VIVO",
  "FINAL": "FINAL",
  "FT": "FT",  // Full Time
  "Q1": "Q1",
  "Q2": "Q2",
  "Q3": "Q3",
  "Q4": "Q4",
  "OT": "PRORR",
  "PPD": "ADI",  // Postponed - Adiado
  "DELAYED": "ATRASADO",
  "CANC": "CANC",  // Canceled - Cancelado
  "TBD": "A definir",
  "Final": "Final",
  "Half": "Intervalo",
  "Halftime": "Intervalo",
  "HT": "INT",

  // Empty States
  "No Games Found": "Nenhum Jogo Encontrado",
  "No games found for this date": "Nenhum jogo encontrado para esta data",
  "No games found for this week": "Nenhum jogo encontrado para esta semana",
  "Try selecting a different date": "Tente selecionar uma data diferente",
  "Try selecting a different week": "Tente selecionar uma semana diferente",
  "Error Loading Games": "Erro ao Carregar Jogos",
  "Failed to load games. Please try again.": "Falha ao carregar jogos. Por favor, tente novamente.",
  "Try Again": "Tentar Novamente",
  "Retry": "Tentar Novamente",
  "View Season Opener": "Ver Abertura da Temporada",

  // Loading States
  "Loading NFL games...": "Carregando jogos da NFL...",
  "Loading games...": "Carregando jogos...",
  "Loading standings...": "Carregando classificação...",

  // Team Labels
  "Visitors": "Visitantes",
  "Home": "Casa",
  "Away": "Visitante",
  "V": "V",  // Visitors abbreviation
  "H": "C",  // Home abbreviation - Casa
  "Q": "Q",  // Quarter abbreviation

  // Game Card Labels
  "NFL": "NFL",
  "NCAA": "NCAA",
  "VS": "VS",
  "at": "em",
  "@": "@",

  // Action Buttons
  "Predict": "Prever",
  "PREDICT": "PREVER",
  "Selected": "Selecionado",
  "SELECTED": "SELECIONADO",
  "Cooldown": "Recarga",
  "COOLDOWN": "RECARGA",
  "Odds": "Cotações",
  "VIEW ODDS": "VER COTAÇÕES",
  "PREDICT LIVE": "PREVER AO VIVO",
  "View Odds": "Ver Cotações",
  "Show Odds": "Mostrar Cotações",

  // Prediction Section
  "AI Pick": "Escolha da IA",
  "AI Pick:": "Escolha da IA:",
  "Analyzing...": "Analisando...",
  "Predicting...": "Prevendo...",
  "Confidence Level": "Nível de Confiança",
  "Confidence Level:": "Nível de Confiança:",
  "HIGH": "ALTO",
  "MED": "MÉDIO",
  "MEDIUM": "MÉDIO",
  "LOW": "BAIXO",
  "confidence": "confiança",
  "Reasoning": "Raciocínio",
  "Reasoning:": "Raciocínio:",
  "Analyze in Chat": "Analisar no Chat",
  "Analyze in Chat →": "Analisar no Chat →",
  "More in Chat": "Mais no Chat",

  // Prediction Bar (Desktop)
  "Game Selected (Max 5)": "Jogo Selecionado (Máx 5)",
  "Games Selected (Max 5)": "Jogos Selecionados (Máx 5)",
  "7 coins/game": "7 moedas/jogo",
  "coins total": "moedas no total",
  "Clear": "Limpar",
  "Clear All": "Limpar Tudo",
  "Predict Winners": "Prever Vencedores",

  // Mobile Prediction Bar - specific translations
  "7 coins/game •": "7 moedas/jogo •",

  // Usage States
  "Need": "Precisa de",
  "Star Coins (You have": "Moedas Estrela (Você tem",
  "Insufficient Star Coins. Need": "Moedas Estrela insuficientes. Precisa de",
  "coins.": "moedas.",

  // Error Messages
  "Failed to load games": "Falha ao carregar jogos",

  // Refund Notice
  "💰": "💰",

  // Close/Navigation
  "Close": "Fechar",
  "Back": "Voltar",
  "Previous": "Anterior",
  "Next": "Próximo",

  // Time Display
  "ET": "ET",
  "PM": "PM",
  "AM": "AM",

  // Quarter Scores Header
  "Quarter": "Quarto",
  "Quarters": "Quartos",

  // Upgrade Notice
  "Upgrade to Premium": "Atualizar para Premium",
  "Get unlimited predictions": "Obtenha previsões ilimitadas",

  // Chat Analysis
  "Analyze this NFL prediction:": "Analisar esta previsão da NFL:",
  "Can you provide a deeper analysis of this matchup?": "Você pode fornecer uma análise mais profunda desta partida?",
  "Prediction:": "Previsão:",

  // SEO Meta
  "NFL Dashboard - Live Scores & Games | PickAI": "Painel da NFL - Placar Ao Vivo e Jogos | PickAI",
  "Track live NFL games, scores, and predictions with real-time updates": "Acompanhe jogos ao vivo da NFL, placares e previsões com atualizações em tempo real",
  "nfl, football, live scores, predictions": "nfl, futebol americano, placar ao vivo, previsões",

  // League/Season Display
  "Regular Season": "Temporada Regular",
  "Playoffs": "Playoffs",
  "Super Bowl": "Super Bowl",
  "Preseason": "Pré-temporada",
  "Wild Card": "Wild Card",
  "Divisional": "Divisional",
  "Conference": "Conferência",

  // Records & Stats
  "Record": "Registro",
  "wins": "vitórias",
  "losses": "derrotas",
  "ties": "empates",

  // Odds Display
  "Spread": "Spread",
  "Moneyline": "Moneyline",
  "Total": "Total",
  "Over": "Acima",
  "Under": "Abaixo",
  "Points": "Pontos",

  // Additional NFL-specific terms
  "Touchdown": "Touchdown",
  "Field Goal": "Field Goal",
  "Safety": "Safety",
  "AFC": "AFC",
  "NFC": "NFC",
  "Division": "Divisão",
  "Wild Card": "Wild Card",

  // Game Info
  "Stadium": "Estádio",
  "Location": "Local",
  "Venue": "Local",
  "Attendance": "Público",
  "Weather": "Clima",

  // Mobile specific
  "Tap to select": "Toque para selecionar",
  "Swipe for more": "Deslize para mais",

  // Standings
  "Standings": "Classificação",
  "Division Leaders": "Líderes de Divisão",
  "Conference": "Conferência",
  "W": "V",  // Wins - Vitórias
  "L": "D",  // Losses - Derrotas
  "T": "E",  // Ties - Empates
  "PCT": "PCT",  // Percentage

  // Week selector
  "Week 1": "Semana 1",
  "Week 2": "Semana 2",
  "Week 3": "Semana 3",
  "Week 4": "Semana 4",
  "Week 5": "Semana 5",
  "Week 6": "Semana 6",
  "Week 7": "Semana 7",
  "Week 8": "Semana 8",
  "Week 9": "Semana 9",
  "Week 10": "Semana 10",
  "Week 11": "Semana 11",
  "Week 12": "Semana 12",
  "Week 13": "Semana 13",
  "Week 14": "Semana 14",
  "Week 15": "Semana 15",
  "Week 16": "Semana 16",
  "Week 17": "Semana 17",
  "Week 18": "Semana 18"
};
